// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2flEW","info":"Note_info__FSJ-Y","note":"Note_note__2h5gj","actions":"Note_actions__uOZT0"};